export default __webpack_public_path__ + "static/media/close_burger.76f27cc6.svg";